import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseTeachers } from '@/api/responses/manage/userBranches'

export namespace UserBranchesApi {
  /**
   * オプション引数(非必須のパラメータ)に使用する型
   */
  export type optionParams = {
    /** 教室ID */
    branchId?: number
    /** 検索文字列 */
    searchText?: string
  }

  /**
   * 先生一覧取得
   *
   * @param options { branchId, searchText } 教室IDと検索文字列
   * @param pageNumber ページ番号
   * @param count 取得件数
   * @returns 先生一覧
   */
  export async function getTeachers(
    options: optionParams,
    pageNumber: number,
    count: number
  ): Promise<ApiResponseTeachers> {
    const params = {
      branchId: options.branchId,
      searchText: options.searchText,
      pageNumber: pageNumber,
      count: count,
    }
    return await ApiBase.get('manage/users/teachers', params)
  }

  /**
   * 先生ユーザ登録API
   *
   * @param nickname ニックネーム
   * @param password パスワード
   * @param branchId 教室ID
   */
  export async function createTeacher(nickname: string, password: string, branchId: number): Promise<void> {
    const params = {
      nickname: nickname,
      password: password,
      branchId: branchId,
    }
    await ApiBase.post('manage/users/teachers', params)
  }

  /**
   * 先生ユーザ情報更新API
   *
   * @param userId ユーザID
   * @param nickname ニックネーム
   */
  export async function updateTeacher(userId: number, nickname: string): Promise<void> {
    const params = {
      nickname: nickname,
    }
    await ApiBase.post(`manage/users/teachers/${userId}`, params)
  }
}
